import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import newpasword_image from "../../assets/images/Auth/newpassword.png";
import logo from "../../assets/images/Auth/tt-logo.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import arrow from "../../assets/images/Auth/back_arrow.png";
import { resetPassword } from "../../apis/apiService";
import { toast } from "react-toastify";

const NewPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();
  const { token: email_token } = useParams();
  // //console.log()("email_token : ", email_token);

  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState("");
  // //console.log()("email_token 1: ", token);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  useEffect(() => {
    // Extract token from URL query parameters
    const queryParams = new URLSearchParams(location.search);
    const extractedToken = queryParams.get("token");
    setToken(email_token || "");
  }, []);

  const onSubmit = async (data) => {
    const { password, confirmPassword } = data;
    if (!token) {
      toast.error("Invalid or missing token.");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    setLoading(true);

    try {
      // Ensure token is passed in the URL and passwords in the body
      const response = await resetPassword(token, password, confirmPassword);

      toast.success(response.message || "Password reset successfull!");
      // //console.log()("reset_response", response.message);

      setTimeout(() => {
        navigate("/login"); // Redirect to login after success
      }, 2000);
    } catch (error) {
      toast.error(error.message || "Invalid or expired token");
    } finally {
      setLoading(false);
    }
  };

  const password = watch("password");
  return (
    <>
      <div className="container-fluid ">
        <div className="row ">
          {/* Image Section */}
          <div className="col-md-7 text-center p-5 login_bg">
            <img
              src={newpasword_image}
              alt="Illustration"
              className="Authleft_img"
            />
          </div>
          {/* Form Section */}
          <div className="col-md-5 p-5">
            <div className="text-center">
              <img src={logo} alt="logo" />
            </div>
            <div className="my-4 form_title">
              <div className="d-flex">
                {/* <a
                  className="back_btn"
                  onClick={() => navigate("/forgot_password")}
                >
                  <img src={arrow} alt="arrow" className="" />
                </a> */}
                <h3>New Password</h3>
              </div>
              <p>Create your New password.</p>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className="login_form">
              {/* New Password Field */}
              <div className="mb-3 position-relative">
                <label htmlFor="password" className="form-label">
                  New Password <span className=" errorMsg">*</span>
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  className="form-control"
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 6,
                      message: "Password must be at least 6 characters",
                    },
                    validate: {
                      noSpaces: (value) =>
                        !/\s/.test(value) || "Password must not contain spaces",
                    },
                  })}
                />
                <span
                  onClick={togglePasswordVisibility}
                  style={{
                    position: "absolute",
                    top: "55px",
                    right: "10px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {/* {showPassword ? <FaEyeSlash /> : <FaEye />} */}
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
                {errors.password && (
                  <small className="text-danger">
                    {errors.password.message}
                  </small>
                )}
              </div>

              {/* Confirm Password Field */}
              <div className="mb-3 position-relative">
                <label htmlFor="confirmPassword" className="form-label">
                  Confirm Password <span className=" errorMsg">*</span>
                </label>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirmPassword"
                  className="form-control"
                  {...register("confirmPassword", {
                    required: "Please confirm your password",
                    // validate: (value) =>
                    //   value === password || "Passwords do not match",
                    validate: {
                      value: (value) =>
                        value === password || "Passwords do not match",
                    },
                    noSpaces: {
                      value: (value) => !/\s/.test(value),
                      message: "Password must not contain spaces",
                    },
                  })}
                />
                <span
                  onClick={toggleConfirmPasswordVisibility}
                  style={{
                    position: "absolute",
                    top: "55px",
                    right: "10px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {/* {showConfirmPassword ? <FaEyeSlash /> : <FaEye />} */}
                  {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
                {errors.confirmPassword && (
                  <small className="text-danger">
                    {errors.confirmPassword.message}
                  </small>
                )}
              </div>

              {/* Submit Button */}
              <div className="d-grid">
                <button type="submit" className="auth_btn" disabled={loading}>
                  {loading ? "Submiting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewPassword;
